// extracted by mini-css-extract-plugin
export default {"offline":"offline_offline__6oR7o"};